module.exports = "  <div class=\"containter\">\n  <a href=\"#\"><img src=\".././assets/img/top-row.png\" id=\"top-row\"></a>\n  <div class=\"centered\">Lifts You Up</div>\n  <a href=\"shop\"><button class=\"centered-btn btn btn-default\" type=\"click\">SHOP NOW</button></a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/juliusbade/Desktop/UnderArmour-Rebuild/src/app/top-row/top-row.component.html
// module id = ../../../../../src/app/top-row/top-row.component.html
// module chunks = main